import { reactive, ref, computed, watch } from '@vue/composition-api'
import * as apiQA from '@/api/qa'

/**
 * 過去年度選択ウィンドウ
 */
export const getGroup = (props, context) => {

  const group1 = reactive({

    choices_revisions_packages: computed(() => {
      return props.parentGroup1.choices_revisions_packages
    }),

    package_id_revision_id: [],

    /**
     * リビジョンを押下した時
     */
    onRevisionClicked: (packageId, searchIndexId) => {

      const packageIdRevisionId = packageId + ',' + searchIndexId
      context.parent.group1.package_id_revision_id = packageIdRevisionId

      context.emit('closeSearchDetailPastYearBookList')
    }
    
  })

  return group1
}
